import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { useGetModulesAndProducts } from "../../hooks/groups/Modules";
import { useGetProfile } from "../../hooks/profiles/Profiles";
import { useLocation } from 'react-router-dom'; // For getting current URL
import AnonymousLinkForm from "./AnonymousLinkForm";
import EmailForm from "./EmailForm";
import ViberSmsForm from "./ViberSmsForm";
import SubMenu from "./SubMenu";
import BatchSendingForm from './BatchSendingFrom';
import ListForm from './ListForm';
import QrForm from './QrForm';
import { useGetProducts } from '../../hooks/groups/Products';
import LoadingSpinner from '../global/LoadingSpinner';

function ManualInvitations2() {
  const { t } = useTranslation();
  const { data: profiles, isLoading:profileIsLoding } = useGetProfile();
  const { data: groups, isLoading:groupIsLoading } = useGetModulesAndProducts()

  const location = useLocation();

  // Track selected component
  const [selectedComponent, setSelectedComponent] = useState("link");

  // Function to update the URL without reloading the page
  const updateURL = (component) => {
    const newURL = `${component}`;
    // Update the URL using the History API without reloading the page
    window.history.pushState(null, '', newURL);
  };

  // Set the component based on the current URL when the component mounts
  useEffect(() => {
    const path = location.pathname.split("/").pop(); // Get the last part of the path
    const validComponents = ["link", "email", "viberSms", "qr", "batch", "list"]; // List of valid components

    if (validComponents.includes(path)) {
      handleOnSelect(path);
    } else {
      handleOnSelect('link');
    }
  }, [location.pathname]);


  const handleOnSelect = (component) => {
    setSelectedComponent(component);
    updateURL(component);
  };

  const renderSelectedComponent = () => {
    switch (selectedComponent) {
      case "link":
        return <AnonymousLinkForm profiles={profiles} groups={groups} />;
      case "email":
        return <EmailForm profiles={profiles} groups={groups} />;
      case "viberSms":
        return <ViberSmsForm profiles={profiles} groups={groups} />;
      case "batch":
        return <BatchSendingForm profiles={profiles} groups={groups} />;
      case "qr":
        return <QrForm profiles={profiles} groups={groups} />;
      case "list":
        return <ListForm profiles={profiles} groups={groups} />;
      default:
        return <AnonymousLinkForm profiles={profiles} groups={groups} />;
    }
  };

  if (profileIsLoding || groupIsLoading) return <LoadingSpinner />

  return (
    <div id="artur-sendOverview">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12 px-4  content">
            <h2 className='px-2'>{t("admin.inv.h1")}</h2>

            <div className="row">
              <div
                className="col-xxl-2 col-xl-3"
                style={{ borderRight: "1px dotted rgba(0, 0, 0, 0.1)" }}
              >
                <SubMenu onSelect={handleOnSelect} />
              </div>
              <hr className='d-xl-none'></hr>
              <div className="col-xxl-8 col-xl-9 list">
                {renderSelectedComponent()}
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default ManualInvitations2;
